import UIAlert from 'UIComponents/alert/UIAlert';
import { ApprovalErrorAlertI18nMessage, ApprovalErrorAlertI18nTitle } from '../i18n/ApprovalErrorAlertI18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ApprovalRequestAccessModalError = props => {
  const {
    errorSubCategory,
    approvalType
  } = props;
  return /*#__PURE__*/_jsx("div", {
    className: "m-bottom-5",
    children: /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nTitle, {
        approvalType: approvalType,
        errorSubCategory: errorSubCategory
      }),
      type: "danger",
      children: /*#__PURE__*/_jsx(ApprovalErrorAlertI18nMessage, {
        approvalType: approvalType,
        errorSubCategory: errorSubCategory
      })
    })
  });
};
export default ApprovalRequestAccessModalError;